import { useContext } from 'react';
import { PortalAuthContext } from '~/contexts/portalAuth';

export default function usePortalAuth() {
  const context = useContext(PortalAuthContext);

  return context;
}
